export enum SearchType {
    SINGLE_SELECTION,
    MULTIPLE_SELECTION,

    /**
     * Indicates that no selection can be made from the search results
     */
    NO_SELECTION
}

/**
 * Used when sending a param to the FUIStackedPageService
 */
export class ExtendedSearchParams {

    readonly searchType: SearchType;
    readonly searchParams: any;

    public static isInstance(object: any): boolean {
        return object != undefined && object instanceof ExtendedSearchParams;
    }

    constructor(searchType: SearchType, searchParams: any = {}) {
        this.searchType = searchType;
        this.searchParams = searchParams;
    }
}
